import React, {useEffect} from 'react';
import { Typography, Grid } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { S3Endpoint } from '../../helpers/config';

import BackgroundImage from '../components/BackgroundImage';

const useStyles = makeStyles(theme => ({

    // cover page section
    cover: {
        position: 'relative'
    },
    coverImg: props => ({
        height: props.imgHeight || 'calc(100% - 75px)',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        backgroundAttachment: 'fixed',
        backgroundSize: 'cover',

        [theme.breakpoints.down('xs')]: {
            backgroundAttachment: 'initial',
            height: props.xsHeight || '50vw',
            backgroundPosition: props.xsBackgroundPosition || 'center',
        },

        [theme.breakpoints.up('xs')]: {
            backgroundAttachment: 'initial',
            height: props.mdHeight || '50vw',
            backgroundPosition: props.mdBackgroundPosition || 'center',
        }

    }),
    coverCurtain: {
        position: 'absolute',
        left: '0',
        right: '0',
        top: '0',
        bottom: '0',
        backgroundColor: 'rgba(255,255,255,0.1)',
    },

    coverTextCurtain: props => ({
        position: 'absolute',
        left: '0',
        top: '0',
        bottom: '0',
        right: '0',
        height: '100%',
        [theme.breakpoints.down('xs')]: {
            height: props.coverTextCurtain && props.coverTextCurtain.xsHeight || '50vw'
        },
        [theme.breakpoints.up('xs')]: {
            height: '50vw',
        }
    }),

    coverText: props => ({
        height: props.coverText && props.coverText.height || '25%',
        textAlign: props.coverText && props.coverText.textAlign || 'center',
        padding: props.coverText && props.coverText.padding || '52px',
        boxShadow: '1px 1px 10px rgba(0,0,0,0.15)',        
        backgroundColor: props.coverText && props.coverText.backgroundColor ||'rgba(0,0,0,0.2)',
        color: 'white',

        [theme.breakpoints.down('xs')]: {
            height: props.coverText && props.coverText.xsHeight || '100%',
            padding: '0px',
        },

        [theme.breakpoints.up('xs')]: {
            height: '100%',
            padding: '0px',
        },


        '& h1': {
            fontWeight: 400,
            letterSpacing: '40px',
            paddingLeft: '20px',
            textShadows: '1px 1px 5px #5b5b5b',

            [theme.breakpoints.down('xs')]: {
                // fontSize: '28px',
                fontWeight: '500',
                letterSpacing: '16px',
                paddingLeft: '8px',
                lineHeight: props.coverText && props.coverText.xsHeight || '100%',
            },
            [theme.breakpoints.up('xs')]: {
                // fontSize: '28px',
                fontWeight: '500',
                letterSpacing: '16px',
                paddingLeft: '8px',
                lineHeight: '50vw',
            }
        }
    }),

    divider: props => ({
        height: props.divider || '1px',
        backgroundColor: theme.palette.primary.dark,
        boxShadow: '1px 1px 10px rgba(181,56,222,1)',
    }),

}));


/**
 * Cover image
 * @param {*} props 
 */
const Cover = (props) => {

    /**
     * props: {
     *      
     *      // image url link
     *      imgUrl: 
     *      
     *      // text shown in the middle
     *      name: string
     * 
     *      // divider height, default is 1px
     *      divider: string
     *      
     *      // covertText style
     *      coverText: {
     *          height
     *          textAlign
     *          padding
     *      }
     *      
     *      coverImgHeight: cover image's height
     * }
     */

    let {imgUrl, name, hideDivider } = props;
    
    const classes = useStyles(props);

    useEffect(() => {
        window.scrollTo(0, 0);
    }, [props]);

    const renderCover = () => {
        return imgUrl ? <div className={classes.coverImg} style={{backgroundImage: 'url(' + S3Endpoint + imgUrl + ')'}} /> : undefined;
    }

    const renderCoverText = () => {
        return name ? (
            <Grid container justify="center" spacing={0} alignContent="center" className={classes.coverTextCurtain}>
                <Grid container item xs={12} justify="center" spacing={0} alignContent="center" className={classes.coverText} >
                    <Typography variant="h1">{name}</Typography> 
                </Grid>
            </Grid>
        ) : undefined;
    }

    const renderChildren = () => {
        return props.children ? {...props.children} : undefined;
    }

    const renderDivider = () => {
        return props.hideDivider ? undefined : <div className={classes.divider} />;
    }

    return (
        <React.Fragment>
            <div className={classes.cover} >
                <div className={classes.coverCurtain} /> 
                {renderCover()}
                {renderCoverText()}
                {renderChildren()}
            </div>
            {renderDivider()}
        </React.Fragment>
    )
} 



export default Cover;


// WEBPACK FOOTER //
// ./src/client/components/Cover.js